import axiosClientNotLoading from "./axiosClientNotLoading";

const PREFIX_URL = "crm/notify";

const notifyApi = {
    getFilter: (params) => {
        const url = `${PREFIX_URL}/index`;
        return axiosClientNotLoading.get(url, { params });
    },
    readOne: (params) => {
        const url = `${PREFIX_URL}/readOne`;
        return axiosClientNotLoading.get(url, { params });
    },
    readAll: (params) => {
        const url = `${PREFIX_URL}/readAll`;
        return axiosClientNotLoading.get(url, { params });
    },
    delete: (params) => {
        const url = `${PREFIX_URL}/deleteOne`;
        return axiosClientNotLoading.get(url, { params });
    },
    deleteAll: (params) => {
        const url = `${PREFIX_URL}/deleteAll`;
        return axiosClientNotLoading.get(url, { params });
    },
}

export default notifyApi;
